module.exports = __webpack_public_path__ + "static/media/note-sticky-regular.fa47a324.png";